// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function IconnavigationarrowDownward24Px2Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 12 18"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M12 12l-1.057-1.057-4.193 4.184V0h-1.5v15.127l-4.185-4.192L0 12l6 6 6-6z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default IconnavigationarrowDownward24Px2Icon
/* prettier-ignore-end */
